import React from 'react';
import { Skeleton, Grid } from '@mui/material';
import styles from './SkeletonsStyles.module.scss';

interface SubCampaignCRSkeletonProps {
  isDigital: boolean;
}

const SubCampaignCRSkeleton: React.FC<SubCampaignCRSkeletonProps> = (props) => {
  const { isDigital } = props;
  const standardHeight = 54;
  return (
    <Grid container >
      <Grid container spacing={2} rowSpacing={1} sx={{ marginBottom: '14px' }} >
        <Grid item sm={9} md={6}>
          <Skeleton variant="text" width="100%" height={standardHeight} />
        </Grid>
      </Grid>

      <Grid container spacing={2} rowSpacing={1} sx={{ marginBottom: '14px' }} >
        <Grid item sm={6} md={3}>
          <Skeleton variant="rounded" width="100%" height={standardHeight} />
          </Grid>
          <Grid item sm={0} md={2} />
          <Grid item sm={6} md={3}>
            <Skeleton variant="rounded" width="100%" height={standardHeight} />
          </Grid>
          <Grid item sm={6} md={4}>
            <Skeleton variant="rounded" width="100%" height={standardHeight} />
          </Grid>
      </Grid>

      <Grid container spacing={2} rowSpacing={1} sx={{ marginBottom: '14px' }} >
        <Grid item sm={6} md={3}>
          <Skeleton variant="rounded" width="100%" height={standardHeight} />
        </Grid>
        <Grid item sm={6} md={3}>
          <Skeleton variant="rounded" width="100%" height={standardHeight} />
        </Grid>
      </Grid>

      <Grid container spacing={2} rowSpacing={1} sx={{ marginBottom: '24px' }} >
        <Grid item sm={9} md={6}>
          <Skeleton variant="rounded" width="100%" height={standardHeight} />
        </Grid>
      </Grid>


      <Grid container spacing={2} rowSpacing={1} sx={{ marginBottom: '14px' }} >
        <Grid item sm={9} md={6}>
          <Skeleton variant="text" width="100%" height={standardHeight} />
        </Grid>
      </Grid>

      <Grid container spacing={2} rowSpacing={1} sx={{ marginBottom: '14px' }} >
        <Grid item sm={6} md={3}>
          <Skeleton variant="rounded" width="100%" height={standardHeight} />
        </Grid>
        <Grid item sm={6} md={3}>
          <Skeleton variant="rounded" width="100%" height={standardHeight} />
        </Grid>
      </Grid>

      <Grid container spacing={2} rowSpacing={1} sx={{ marginBottom: '14px' }} >
        <Grid item sm={6} md={3}>
          <Skeleton variant="rounded" width="100%" height={standardHeight} />
        </Grid>
        <Grid item sm={6} md={3}>
          <Skeleton variant="rounded" width="100%" height={standardHeight} />
        </Grid>
      </Grid>
    </Grid>
  );
};

export default SubCampaignCRSkeleton;
